module.exports = "/static/assets/479c3dcb836b638e0bf8e9cadf5f5e3b.png";